import {
  WIFI_THERMOSTATS_REQUEST,
  WIFI_THERMOSTATS_REQUEST_SUCCESS,
  WIFI_THERMOSTATS_REQUEST_FAILED,
  WifiThermostatsActionsTypes,
  WifiThermostatsState,
} from '../types/wifiThermostats';

const initialState: WifiThermostatsState = {
  items: [],
  loading: false,
  refreshing: false,
  error: '',
  selected: null,
};

export default (state = initialState, action: WifiThermostatsActionsTypes):
WifiThermostatsState => {
  switch (action.type) {
    case WIFI_THERMOSTATS_REQUEST:
      return {
        ...state,
        items: [],
        loading: true,
        error: '',
      };
    case WIFI_THERMOSTATS_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload,
      };
    case WIFI_THERMOSTATS_REQUEST_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    default:
      return state;
  }
};
